let getConsumerIdentification = _value => {
  let value = _value?.toString()?.replace(/\s\s+/g, ' ').trim()
  try {
    if (!value) return ''
    if (/[a-z.]/i.test(value)) return value
    // Bug real (auditoría 2026-08-16): si la identificación no tenía ningún dígito (ej. "-",
    // "()"), value quedaba en "" tras el replace, parseInt("") es NaN, y NaN.toLocaleString(...)
    // devuelve el string truthy "NaN" — el `|| value` de abajo nunca disparaba y la UI mostraba
    // literalmente el texto "NaN" en vez del valor crudo original.
    const original = value
    value = value.replace(/\D/g, '')
    const parsed = parseInt(value)
    return Number.isNaN(parsed) ? original : parsed.toLocaleString('es-AR')
  } catch {}

  return value
}

module.exports = getConsumerIdentification
